import React, { useContext, useState } from "react";

import {
  Box,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import Typography from "@mui/material/Typography";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import AddBoxIcon from "@mui/icons-material/AddBox";
import "./accordionscommune.scss";

import MuiAccordionSummary, {
  accordionSummaryClasses,
} from "@mui/material/AccordionSummary";
import { AuthContext } from "../../Context/AuthContext";
import useWithDimension from "../../Hooks/useWithDimension";
import AccordionsVillage from "../Village/AccordionsVillage";
import { useGetCommuneByDistrict } from "../../Hooks/useGetCommuneByDistrict";
import CommuneForm from "../../Components/Commune/CommuneForm";
import CommuneAction from "../../Components/Commune/CommuneAction";

// 👉 Accordion: No border
const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  border: "none",
  "&::before": {
    display: "none",
  },
}));

// 👉 AccordionSummary: No arrow icon
const AccordionSummary = styled((props) => <MuiAccordionSummary {...props} />)(
  ({ theme }) => ({
    backgroundColor: "rgba(0, 0, 0, .03)",
    flexDirection: "row-reverse",
    [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
    {
      transform: "rotate(90deg)",
    },
    [`& .${accordionSummaryClasses.content}`]: {
      marginLeft: theme.spacing(1),
    },
    ...theme.applyStyles?.("dark", {
      backgroundColor: "rgba(255, 255, 255, .05)",
    }),
  })
);

// 👉 AccordionDetails: No top border
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "none",
}));

export default function AccordionsCommune({ districtData }) {
  const { t } = useContext(AuthContext);

  const { loading, refetch, tableData } = useGetCommuneByDistrict({
    districtMunicipalitiesId: districtData?._id,
  });

  const [expanded, setExpanded] = React.useState();

  const handleChange = (panelIndex) => (event, newExpanded) => {
    setExpanded(newExpanded ? panelIndex : false);
  };
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // ======================= Resize width Screen ======================
  const { width } = useWithDimension();

  return (
    <div className="page-container">
      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width="4%"
                  sx={{ paddingY: "3px !important" }}
                >
                  {t("no")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width="20%"
                  sx={{ paddingY: "3px !important" }}
                >
                  {t("thead_code")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width="20%"
                  sx={{ paddingY: "3px !important" }}
                >
                  {t("thead_name")}(KH)
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width="20%"
                  sx={{ paddingY: "3px !important" }}
                >
                  {t("thead_name")}(ENG)
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width="20%"
                  sx={{ paddingY: "3px !important" }}
                >
                  {t("thead_type")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title-end")}
                  width="16%"
                  sx={{ paddingY: "3px !important" }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="flex-end"
                  >
                    <IconButton onClick={() => handleOpen()}>
                      <AddBoxIcon sx={{ color: "#223D97" }} />
                    </IconButton>
                  </Stack>

                  {open && (
                    <CommuneForm
                      open={open}
                      handleClose={handleClose}
                      setRefetch={refetch}
                      dialogTitle="Create"
                      districtMunicipalitiesId={districtData?._id}
                    />
                  )}
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <TableCell colSpan={6} sx={{ padding: 0 }}>
                  <div className="commune">
                    <Stack direction="column" spacing={0.7}>
                      {tableData?.map((row, index) => (
                        <Accordion
                          key={index}
                          expanded={expanded === index}
                          onChange={handleChange(index)}
                          className="accordion"
                        >
                          <Stack direction="row" alignItems="center" sx={{ paddingRight: 1 }}>

                            <AccordionSummary
                              className="accordion-summary"
                              aria-controls={`panel${index}-content`}
                              id={`panel${index}-header`}
                            >
                              <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                                className="row"
                              >
                                <Typography className="cell" width="4.5%">
                                  {index + 1}
                                </Typography>
                                <Typography className="cell" width="24%">
                                  {row?.commune_sangkat_code}
                                </Typography>
                                <Typography className="cell" width="24%">
                                  {row?.commune_sangkat_name_kh}
                                </Typography>
                                <Typography className="cell" width="24%">
                                  {row?.commune_sangkat_name_en}
                                </Typography>
                                <Typography className="cell" width="23.5%">
                                  {row?.commune_sangkat_type === "sangkat" ? t("thead_sangkat") : t("thead_commune")}
                                </Typography>

                              </Stack>
                            </AccordionSummary>

                            <Typography
                              className="cell"
                              width="16%"
                            >
                              <CommuneAction editData={row} setRefetch={refetch} districtMunicipalitiesId={districtData?._id} />
                            </Typography>
                          </Stack>
                          <AccordionDetails className="accordion-details">
                            <AccordionsVillage communeData={row} districtMunicipalitiesId={districtData?._id} />
                          </AccordionDetails>
                        </Accordion>
                      ))}
                    </Stack>
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}
